import { ComingSoon } from '../RevenueShare/ComingSoon/ComingSoon'

export const GitbookScreens = [<ComingSoon />]
